import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import Image from 'src/components/atomic/atom/Image'
import { COLOR } from 'src/constants/colors'
import styled from 'styled-components'
import { LoginProps } from 'src/views/Account/Login'
import google_logo from 'src/assets/imgs/logo/google.png'
import { useScriptHook } from 'src/hooks/useScript.hook'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID

// 구글 로그인 컴포넌트
const GoogleLoginForm = (props: { data: LoginProps }) => {
  const { GoogleLoginSuccessHandler } = props.data
  const { t } = useTranslation()
  const googleSignInButton = useRef<HTMLDivElement>(null)
  const { setMediaStyle } = useMediaQueryHook()
  const status = useScriptHook(`https://accounts.google.com/gsi/client`, {
    removeOnUnmount: false,
  })

  const renderButtonStyle = {
    type: 'standard',
    size: 'small',
    width: setMediaStyle('396px', '600px', '360px'),
    shape: 'square',
  }

  useEffect(() => {
    if (typeof window.google !== 'undefined') {
      window.google.accounts.id.initialize({
        client_id: `${CLIENT_ID}`,
        callback: GoogleLoginSuccessHandler,
      })

      googleSignInButton.current &&
        window.google.accounts.id.renderButton(googleSignInButton.current, renderButtonStyle)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, GoogleLoginSuccessHandler])

  return (
    <>
      <GoogleLoginWrap
        width={setMediaStyle('396px', '100%', '100%')}
        height={setMediaStyle('52px', '49px', '52px')}
      >
        {/*구글 로그인 라이브러리 - 영역 감춤*/}
        <GoogleOriginBox>
          <div ref={googleSignInButton} id="google-login-button" />
        </GoogleOriginBox>
        {/*노출 되는 커스텀 버튼 */}
        <SocialLoginBtn
          width={setMediaStyle('396px', '100%', '100%')}
          height={setMediaStyle('52px', '49px', '52px')}
          className="login_google"
        >
          <Image $ImgSrc={google_logo} width={'20px'} height={'20px'} />
          <Span option={'small_bold'} display={'flex'} $text_align={'left'}>
            {t('BUTTON.SIGN_IN_GOOGLE', { defaultValue: 'Sign in with Google' })}
          </Span>
          <Svg name={'arrow'} />
        </SocialLoginBtn>
      </GoogleLoginWrap>
    </>
  )
}

export default GoogleLoginForm

const GoogleLoginWrap = styled.div<{ width: string; height: string }>`
  position: relative;
  overflow: hidden;
  cursor: pointer;

  #google-login-button iframe {
    cursor: pointer;
    width: ${(props) => props.width} !important;
    height: ${(props) => props.height} !important;
    margin: 0 auto !important;
  }
`
const GoogleOriginBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
`

export const SocialLoginBtn = styled.button<{ width: string; height: string }>`
  display: flex;
  gap: 12px;
  width: ${(props) => props.width} !important;
  height: ${(props) => props.height};
  line-height: ${(props) => props.height};
  align-items: center;
  border: 1px solid ${COLOR.black20};
  border-radius: 12px;
  -webkit-tap-highlight-color: rgba(240, 240, 240, 0.1);
  padding: 0 12px;
  margin: 0 auto;
  background: none;
`
